import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import { Button } from '../ui/button';
import { ArrowRight, Calendar } from 'lucide-react';
import { motion } from 'framer-motion';

export default function CTASection() {
  const { t } = useLanguage();

  return (
    <section
      data-testid="cta-section"
      className="bg-[#2D78F6] py-20 md:py-28"
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-3xl sm:text-4xl lg:text-5xl font-light text-white leading-tight tracking-tight mb-6"
          style={{ fontFamily: 'Gabarito, sans-serif' }}
        >
          {t.cta.title}
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="text-lg text-white/80 leading-relaxed mb-10 max-w-2xl mx-auto"
          style={{ fontFamily: 'Poppins, sans-serif' }}
        >
          {t.cta.subtitle}
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="flex flex-col sm:flex-row gap-4 justify-center"
        >
          <a href="https://admissions.ofalycee.fr" target="_blank" rel="noopener noreferrer">
            <Button
              data-testid="cta-primary-btn"
              size="lg"
              className="bg-white text-[#14274B] hover:bg-[#14274B] hover:text-white px-8 py-6 text-base font-medium transition-all duration-300 group"
              style={{ fontFamily: 'Poppins, sans-serif' }}
            >
              <Calendar className="mr-2 h-4 w-4" />
              {t.cta.primary}
            </Button>
          </a>
          <a href="https://admissions.ofalycee.fr" target="_blank" rel="noopener noreferrer">
            <Button
              data-testid="cta-secondary-btn"
              size="lg"
              variant="outline"
              className="border-white/30 text-white hover:bg-white hover:text-[#14274B] px-8 py-6 text-base font-medium transition-all duration-300"
              style={{ fontFamily: 'Poppins, sans-serif' }}
            >
              {t.cta.secondary}
              <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
          </a>
        </motion.div>
      </div>
    </section>
  );
}
